<div class="dropdown dropdown-dda">
  <button class="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
    <img src="/assets/svg/icon_download.svg" alt="download" width="16" height="16" class="icon-download-dda"> Exportar
  </button>
  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
    <a class="dropdown-item" href="javascript: void(0);" (click)="selected('CNAB');">CNAB</a>
    <a class="dropdown-item" href="javascript: void(0);" (click)="selected('EXCEL');">EXCEL</a>
  </div>
</div>
